export default "__VITE_ASSET__BvDXpm4a__"